TS.ns('WL');

WL.leasingOfferPropertiesModel = new Class({
    Extends: WL.documentBase,

    createProperties: function (config) {
        var me = this;

        me.parent(config);   

        var propertyList = me.getDomainProperty('PropertyList');

        if (propertyList) {
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
        }
    },
     
    onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text'); 
        rec.EditorType = new ko.observable('Text');
    },

    onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;
           
        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        })
    }

});